import { classEnum, type EnumType } from "./base";
import type { GatewayProviderEnum } from "./gateway_provider.enum";

export const PaymentGatewayEnum = new (class extends classEnum([
    {
        label: "XenditV2",
        value: "XenditV2",
        provider: "xendit",
    },
    {
        label: "XenditV3",
        value: "XenditV3",
        provider: "xendit",
    },
] as const satisfies EnumType<{
    provider: GatewayProviderEnum.Values;
}>) {
    public get valuesXendit() {
        return this.select.filter((v) => v.provider === "xendit").map((v) => v.value);
    }

    public get selectXendit() {
        return this.select.filter((v) => v.provider === "xendit");
    }

    public get ValuesXendit(): this["valuesXendit"][number] {
        throw new Error("ValuesXendit can't be used as a value");
    }
})();

export namespace PaymentGatewayEnum {
    export type Labels = (typeof PaymentGatewayEnum)["labels"][number];
    export type Values = (typeof PaymentGatewayEnum)["values"][number];
    export type ValuesXendit = (typeof PaymentGatewayEnum)["valuesXendit"][number];
}
